import * as React from "react";
import { HelmetProvider } from "@dr.pogodin/react-helmet";
import { Store } from "redux";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import AppProvider from "./app";

interface RootProps {
  store: Store;
}

const Root: React.FC<RootProps> = ({ store }) => (
  <HelmetProvider>
    <Provider store={store}>
      <BrowserRouter>
        <AppProvider />
      </BrowserRouter>
    </Provider>
  </HelmetProvider>
);

export default Root;
